module.exports = __webpack_public_path__ + "img/no-empty.f32c4a38.png";